import TextLayout from "~/components/common/TextLayout";
import htmlContent from "~/data/legal-document/terms_7.html?raw";

export default function TermsOfServicePage() {
  return <TextLayout title="Terms of Service" htmlContent={htmlContent} />;
}
